export default __webpack_public_path__ + "static/media/TraceFill.b86ba242.svg";